/* -------------------------------------------------------------------------- */
/*  Signup.tsx                                                                */
/* -------------------------------------------------------------------------- */

import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

const Signup = () => {
  return (
    <Box
      component="section"
      id="signup"
      sx={{
        width: "100%",
        py: { xs: 10, md: 14 },
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          opacity: 0.7,
          background:
            "radial-gradient(900px 420px at 20% 20%, rgba(77, 222, 128, 0.35), transparent 60%), radial-gradient(800px 360px at 80% 35%, rgba(77, 222, 128, 0.35), transparent 60%), radial-gradient(1000px 520px at 50% 110%, rgba(77, 222, 128, 0.35), transparent 60%)",
        }}
      />

      <Container maxWidth="md" sx={{ position: "relative" }}>
        <Box
          sx={{
            borderRadius: 5,
            p: { xs: 3, sm: 4, md: 5 },
            background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
            border: "1px solid rgba(255,255,255,0.14)",
            backdropFilter: "blur(10px)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: "white",
              fontWeight: 900,
              letterSpacing: -0.6,
              mb: 3,
              lineHeight: 1.15,
            }}
          >
            Build Repeatable, Effective Discipleship Pathways for Your Church
          </Typography>

          <Box display="flex" gap={2} justifyContent="center" flexWrap="wrap">
            <Button
              variant="contained"
              sx={{
                background: "#4ade80",
                color: "#0f172a",
                borderRadius: "9999px",
                px: 4,
                py: 1.5,
                fontSize: "1rem",
                boxShadow: "0px 10px 30px rgba(0,0,0,0.35)",
                "&:hover": { background: "#22c55e" },
                textTransform: "none",
                fontWeight: 900,
                mt: 4,
              }}
              size="large"
              href="/register/"
              endIcon={<ArrowForward />}
            >
              Explore PATHWAYS for free
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Signup;